import { 
    Grid, 
    Tab, 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead,
    TableRow, 
    Tabs,
    Typography
} from "@mui/material";

import { useState } from "react";

import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";

import missionNeeds from "../../../assets/DOJsons/missionNeeds.json";
import conops from "../../../assets/DOJsons/conops.json";
import capabilities from "../../../assets/DOJsons/capabilities.json";
import requirements from "../../../assets/DOJsons/requirements.json";
import ingestedArtifacts from "../../../assets/DOJsons/ingestedArtifacts.json";

function ArtifactsTab() {
    const [selectedTopIndex, updateSelectedTopIndex] = useState(0)
    const [selectedInnerIndex, updateSelectedInnerIndex] = useState(0)
    return (
        <Grid container>
            <MDBox pt={1} bgColor="grey-100">
                <MDBox>
                    <Tabs
                        value={selectedTopIndex}
                        onChange={(_, index) => updateSelectedTopIndex(index)}
                    >
                        <Tab label="Decomposed Objects"/>
                        <Tab label="Ingested Artifacts"/>
                    </Tabs>
                </MDBox>
                
                {/* Decomposed Objects Tab */}
                {selectedTopIndex === 0 && (
                    <MDBox bgColor="grey-300">
                        <Grid container spacing={1}>
                            <Grid item lg={12}>
                                <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                    <MDTypography variant="body2" sx={{color: "dark_teal.main"}}>
                                        The decomposed objects related specifically to the asset have been categorized and shown below to facilitate traceability.
                                    </MDTypography>
                                </MDBox>
                            </Grid>

                            <Grid item lg={12}>
                                <MDBox bgColor="grey-100" pt={1}>
                                    <MDBox>
                                        <Tabs
                                            value={selectedInnerIndex}
                                            onChange={(_, index) => updateSelectedInnerIndex(index)}
                                        >
                                            <Tab label="Mission Needs"/>
                                            <Tab label="Capabilities"/>
                                            <Tab label="ConOps"/>
                                            <Tab label="Requirements"/>
                                        </Tabs>
                                    </MDBox>

                                    {selectedInnerIndex === 0 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2" sx={{color: "dark_teal.main"}}>
                                                            Mission needs define the high-level operational goals or problems that 
                                                            drive the justification for a system or capability, without specifying how they
                                                            will be achieved.
                                                        </MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}> 
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .55)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell sx={{color: "text.main"}}>Title</TableCell>
                                                                    <TableCell sx={{color: "text.main"}}>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {missionNeeds.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>
                                                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                                                {row.description}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}

                                    {selectedInnerIndex === 1 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2" sx={{color: "dark_teal.main"}}>
                                                            Capabilities describe the broad functions or effects that a system must be 
                                                            able to perform or deliver in order to meet the mission needs.
                                                        </MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .55)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell sx={{color: "text.main"}}>Title</TableCell>
                                                                    <TableCell sx={{color: "text.main"}}>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {capabilities.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>
                                                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                                                {row.description}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}

                                    {selectedInnerIndex === 2 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2" sx={{color: "dark_teal.main"}}>
                                                            ConOps outlines the envisioned operational context, scenarios, and 
                                                            interactions that illustrate how capabilities will be employed to achieve 
                                                            mission goals.
                                                        </MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .55)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell sx={{color: "text.main"}}>Title</TableCell>
                                                                    <TableCell sx={{color: "text.main"}}>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {conops.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>
                                                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                                                {row.description}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}

                                    {selectedInnerIndex === 3 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2" sx={{color: "dark_teal.main"}}>
                                                            Requirements define the specific, measurable, and testable technical or 
                                                            operational criteria that a system must satisfy to support the ConOps and 
                                                            deliver the necessary capabilities.
                                                        </MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .55)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell sx={{color: "text.main"}}>Title</TableCell>
                                                                    <TableCell sx={{color: "text.main"}}>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {requirements.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>
                                                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                                                {row.description}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                )}

                {/* Ingested Artifacts Tab */}
                {selectedTopIndex === 1 && (
                    <Grid container spacing={2}>
                        <Grid item lg={12}>
                            <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                <MDTypography variant="body2" sx={{color: "dark_teal.main"}}>
                                    Source materials—such as documents, presentations, videos, and other 
                                    media—that have been collected and processed for decomposition into 
                                    structured data objects.
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item lg={12}>
                            <TableContainer sx={{maxHeight: "calc(100vh * .54)"}}>
                                <Table stickyHeader>
                                    <TableHead sx={{ display: "table-header-group" }}>
                                        <TableRow>
                                            <TableCell sx={{color: "text.main"}}>Title</TableCell>
                                            <TableCell sx={{color: "text.main"}}>Description</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ingestedArtifacts.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell >{row.title}</TableCell>
                                                <TableCell>
                                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                        {row.description}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                )}

            </MDBox>
        </Grid>
    )
}

export default ArtifactsTab;